
import { Badge } from "@/components/ui/badge";
import { FAQCategory } from "@/data/faqData";

interface FAQFilterProps {
  categories: FAQCategory[];
  selectedCategory: string | null;
  onCategorySelect: (categoryId: string | null) => void;
}

const FAQFilter = ({ categories, selectedCategory, onCategorySelect }: FAQFilterProps) => {
  return (
    <div className="mb-8">
      <h3 className="text-lg font-semibold text-white mb-4">Filter by Category</h3>
      <div className="flex flex-wrap gap-3">
        <Badge
          className={`cursor-pointer px-4 py-2 transition-all duration-300 ${
            selectedCategory === null
              ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
              : "bg-white/10 text-gray-300 hover:bg-white/20"
          }`}
          onClick={() => onCategorySelect(null)}
        >
          All Categories
        </Badge>
        {categories.map((category) => (
          <Badge
            key={category.id}
            className={`cursor-pointer px-4 py-2 transition-all duration-300 ${
              selectedCategory === category.id
                ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white"
                : "bg-white/10 text-gray-300 hover:bg-white/20"
            }`}
            onClick={() => onCategorySelect(category.id)}
          >
            {category.name}
          </Badge>
        ))}
      </div>
    </div>
  );
};

export default FAQFilter;
